import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import htmlSerializer from '../../utils/htmlSerializer';
const NpsSurvey = ({ value, onClose, setBrazeCustomAttribute, }) => {
    const [npsValue, setNpsValue] = useState('not set');
    const [npsText, setNpsText] = useState();
    const [pageNumber, setPageNumber] = useState(0);
    const [textVariant, setTextVariant] = useState(1);
    const handleNextPage = (attribute) => {
        if (attribute && attribute === 'nps_survey_score_number' && npsValue) {
            setBrazeCustomAttribute({ key: attribute, value: npsValue });
        }
        if (attribute && attribute === 'nps_survey_message_text' && npsText) {
            setBrazeCustomAttribute({ key: attribute, value: npsText });
        }
        pageNumber < value.length - 1 ? setPageNumber(pageNumber + 1) : onClose();
    };
    const getTextVariantByNPSValue = (npsValue) => {
        const npsValueAsNumber = parseInt(npsValue);
        if ([9, 10].includes(npsValueAsNumber)) {
            return 3;
        }
        else if ([7, 8].includes(npsValueAsNumber)) {
            return 2;
        }
        return 1;
    };
    return (_jsx(React.Fragment, { children: value[pageNumber].map((content, index) => htmlSerializer({
            content,
            onClose,
            onChange: (name, formValue) => {
                switch (name) {
                    case 'nps-value':
                        setNpsValue(formValue);
                        setTextVariant(getTextVariantByNPSValue(formValue));
                        break;
                    case 'nps-text':
                        setNpsText(formValue);
                        break;
                }
            },
            key: `nps-survey-${index}`,
            handleNextPage: handleNextPage,
            textVariant,
            npsValue,
        })) }));
};
export default NpsSurvey;
//# sourceMappingURL=NpsSurvey.js.map